import React from 'react';
import PropTypes from 'prop-types';
import max from 'lodash/max';

import './styles.css';

class SimpleBarChart extends React.PureComponent {
  static propTypes = {
    chartData: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number.isRequired,
        displayValue: PropTypes.string,
        label: PropTypes.string,
        color: PropTypes.string,
        width: PropTypes.number,
        isGap: PropTypes.bool,
      }),
    ),
    titles: PropTypes.arrayOf(PropTypes.string),
    barWidth: PropTypes.number,
    maxBarHeight: PropTypes.number,
    displayValueColor: PropTypes.string,
  };

  static defaultProps = {
    barWidth: 115,
    maxBarHeight: 150,
  };

  getBlockStyles(data) {
    const { chartData, barWidth, maxBarHeight } = this.props;

    const styles = {};
    styles.width = `${data.width || barWidth}px`;
    const values = chartData.map((data) => data.value);
    const maxBarValue = max(values);
    styles.height = `${Math.floor((maxBarHeight * data.value) / maxBarValue)}px`;

    styles['backgroundColor'] = data.color || '#8bc100';
    if (data.isGap) {
      styles['marginRight'] = '50px';
    }
    styles.position = 'relative';
    return styles;
  }

  getBlockColor(data) {
    const { displayValueColor } = this.props;
    const styles = {};
    styles.color = displayValueColor || data.color || '#8bc100';
    return styles;
  }

  render() {
    const { chartData, titles } = this.props;
    if (!chartData || chartData.length <= 0) {
      return null;
    }
    return (
      <div data-cy="bar-chart-container" className="bar-chart-container">
        {titles && titles.length > 0 && (
          <div className="bar-titles-container">
            {titles.map((title) => (
              <div key={title} className="bar-title">
                {title}
              </div>
            ))}
          </div>
        )}
        <div className="x-axis">
          {chartData.map((data, index) => (
            <div
              key={`${data.label}-${index}`}
              className="bar-block"
              style={this.getBlockStyles(data)}
            >
              <div className="bar-label">{data.label}</div>
              <div className="bar-display-value" style={this.getBlockColor(data)}>
                {data.displayValue}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default SimpleBarChart;
